export default "__VITE_ASSET__BVtpr4x3__"